import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class CandidateEmail extends SendRequest
{
    async SendCandidateJobEmail(params, router, entity_id)
    {
        var send_candidate_email = API.client.applicant.SEND_EMAIL.replace('$applicant_id', router.query.applicant_id || entity_id);
        try 
        {
            const result = await axios.post(send_candidate_email,
            params,
            this.setMultipartHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async SendCandidateGeneralEmail(params, router, entity_id)
    {
        var send_candidate_email = API.client.applicant.GENERAL_SEND_EMAIL.replace('$candidate_id', router.query.candidate_id || entity_id);
        
        try 
        {
            const result = await axios.post(send_candidate_email,
            params,
            this.setMultipartHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async SendKanbanEmail(params, router)
    {
        var send_candidate_email = API.client.kanban.SEND_EMAIL.replace('$job_id', router.query.job_id);
        
        try 
        {
            const result = await axios.post(send_candidate_email,
            params,
            this.setMultipartHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }
}
